/** @format */

import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { AiFillStar } from "react-icons/ai";
import { CiStar } from "react-icons/ci";
import RatingReact from "react-rating";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  customer_review,
  get_product_review,
  messageClear,
} from "../store/reducers/homeReducer";
import { useProductTracking } from "../utils/utils"; // ✅ ajout
import Paginations from "./Paginations";
import Ratings from "./Ratings";
import RatingTemp from "./RatingTemp";

const Reviews = (props) => {
  const {
    customerInfo,
    reviewsSuccess,
    reviews,
    rating_review,
    totalReviews,
    parPage,
    reviewsError,
    productId,
    currentPage,
  } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { trackAction } = useProductTracking(productId); // ✅ hook au niveau composant

  const [pageNumber, setPageNumber] = useState(1);
  const [userRating, setUserRating] = useState(0);
  const [userReview, setUserReview] = useState("");

  useEffect(() => {
    setUserRating(0);
    setUserReview("");
  }, [productId]);

  const review_submit = async (e) => {
    e.preventDefault();
    const reviewObject = {
      name: customerInfo.name,
      rating: parseInt(userRating),
      review: userReview,
      productId: productId,
    };
    try {
      await dispatch(customer_review(reviewObject)).unwrap();
      dispatch(get_product_review({ productId, pageNumber }));
      trackAction("sendReview"); // ✅ tracké après succès
      setUserRating(0);
      setUserReview("");
    } catch (error) {
      console.error("Erreur lors de l'envoi de l'avis :", error);
      toast.error(`${t("Error sending review")}`);
    }
  };

  useEffect(() => {
    if (productId && productId.length === 24) {
      if (
        reviews[0]?.productId.length === 24 &&
        productId !== reviews[0]?.productId
      ) {
        dispatch(get_product_review({ productId, pageNumber }));
      } else if (pageNumber !== currentPage) {
        dispatch(get_product_review({ productId, pageNumber }));
      }
    }
  }, [dispatch, pageNumber, productId, reviews, currentPage]);

  useEffect(() => {
    if (reviewsError) {
      toast.error(reviewsError);
      setTimeout(() => dispatch(messageClear()), 2000);
    }
    if (reviewsSuccess) {
      setTimeout(() => dispatch(messageClear()), 2000);
    }
  }, [reviewsError, reviewsSuccess, dispatch]);

  let averageRating = 0;
  if (rating_review && rating_review.length > 0 && totalReviews > 0) {
    for (let i = 0; i < rating_review.length; i++) {
      averageRating += rating_review[i].rating * rating_review[i].sum;
    }
    averageRating = averageRating / totalReviews;
  }

  return (
    <div className='mt-8'>
      <div className='flex gap-10 md:flex-col'>
        <div className='flex flex-col gap-2 justify-start items-start py-4'>
          <div>
            <span className='text-6xl font-semibold'>
              {averageRating.toFixed(2)}
            </span>
            <span className='text-3xl font-medium text-gray-500'>/5</span>
          </div>
          <div className='flex text-4xl'>
            <Ratings ratings={averageRating.toFixed(2)} />
          </div>
          <p className='text-sm text-slate-600'>
            {totalReviews} {t("Ratings")}
          </p>
        </div>
        <div>
          {rating_review.map((r, i) => (
            <RatingTemp
              key={i}
              rating={r.rating}
              totalRatings={totalReviews}
              numberRatings={r.sum}
            />
          ))}
        </div>
      </div>

      <h2 className='text-slate-600 text-xl font-bold py-5'>
        {t("Products Reviews")} {totalReviews}
      </h2>

      <div className='flex flex-col gap-5 pb-10 pt-4'>
        {totalReviews > 0 ? (
          reviews.map((review, index) => (
            <div key={index} className='flex flex-col gap-1'>
              <div className='flex justify-between items-center'>
                {review.rating > 0 && (
                  <RatingTemp
                    rating={review.rating}
                    totalRatings={5}
                    numberRatings={review.rating}
                  />
                )}
                <p className='text-sm text-slate-600'>{review.date}</p>
              </div>
              <p className='text-md text-slate-800 text-justify'>
                {review.review}
              </p>
              <span className='flex gap-3'>
                <img
                  className='w-[25px] h-[25px] object-contain'
                  src='/images/customer.png'
                  alt=''
                />
                <span className='text-md text-slate-600'>{review.name}</span>
              </span>
            </div>
          ))
        ) : (
          <div>{t("Null reviews")}</div>
        )}
        <div className='flex justify-end'>
          {totalReviews > parPage && (
            <Paginations
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              totalItem={totalReviews}
              parPage={parPage}
              showItem={Math.floor(totalReviews / parPage) + 1}
            />
          )}
        </div>
      </div>

      <div>
        {customerInfo ? (
          <div className='flex flex-col gap-3'>
            <div className='flex gap-2'>
              <RatingReact
                onChange={(e) => setUserRating(e)}
                initialRating={userRating}
                emptySymbol={
                  <span className='text-slate-600 text-4xl'>
                    <CiStar />
                  </span>
                }
                fullSymbol={
                  <span className='text-[#edbb0e] text-4xl'>
                    <AiFillStar />
                  </span>
                }
              />
            </div>
            <form onSubmit={review_submit}>
              <textarea
                required
                onChange={(e) => setUserReview(e.target.value)}
                value={userReview}
                name='userReview'
                id='userReview'
                cols={30}
                rows={5}
                className='border outline-0 p-3 w-full'
              />
              <div className='mt-2 mb-4'>
                <button className='bg-[#edbb0e] text-white py-2 px-2 rounded-sm'>
                  {t("SUBMIT")}
                </button>
              </div>
            </form>
          </div>
        ) : (
          <div>
            <Link
              to='/login'
              className='py-1 px-5 rounded-sm text-blue-500 text-2xl'
            >
              {t("Login")}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Reviews;
